__turbopack_context__.v({
  "aboutContainer": "TeamDetails-module-scss-module__mIZZza__aboutContainer",
  "aboutContent": "TeamDetails-module-scss-module__mIZZza__aboutContent",
  "aboutTitle": "TeamDetails-module-scss-module__mIZZza__aboutTitle",
  "actions": "TeamDetails-module-scss-module__mIZZza__actions",
  "addPill": "TeamDetails-module-scss-module__mIZZza__addPill",
  "addPill1": "TeamDetails-module-scss-module__mIZZza__addPill1",
  "delete": "TeamDetails-module-scss-module__mIZZza__delete",
  "emptyTag": "TeamDetails-module-scss-module__mIZZza__emptyTag",
  "fundingStage": "TeamDetails-module-scss-module__mIZZza__fundingStage",
  "iTag": "TeamDetails-module-scss-module__mIZZza__iTag",
  "logoTagsContainer": "TeamDetails-module-scss-module__mIZZza__logoTagsContainer",
  "nameAndActions": "TeamDetails-module-scss-module__mIZZza__nameAndActions",
  "nameTagContainer": "TeamDetails-module-scss-module__mIZZza__nameTagContainer",
  "notification": "TeamDetails-module-scss-module__mIZZza__notification",
  "profile": "TeamDetails-module-scss-module__mIZZza__profile",
  "tagDivider": "TeamDetails-module-scss-module__mIZZza__tagDivider",
  "tags": "TeamDetails-module-scss-module__mIZZza__tags",
  "tags2": "TeamDetails-module-scss-module__mIZZza__tags2",
  "tags3": "TeamDetails-module-scss-module__mIZZza__tags3",
  "tagsContainer": "TeamDetails-module-scss-module__mIZZza__tagsContainer",
  "teamLogo": "TeamDetails-module-scss-module__mIZZza__teamLogo",
  "teamName": "TeamDetails-module-scss-module__mIZZza__teamName",
});
